import { CrudBaseComponent } from '$core/base/_crud.service';
import { OldAddress } from '$core/models/old-address';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AddressesService extends CrudBaseComponent {
  public apiRoute = '/addresses';
  public MODEL = OldAddress;
}
